import { defineStore } from 'pinia';

export const useNavbarStore = defineStore('navbar', {
  state: () => ({
    showNavbar: true
  }),
  actions: {
    toggleNavbar() {
      this.showNavbar = !this.showNavbar;
    }
  }
});